import { InputSelect } from 'components/InputSelect'
import { Control, FieldValues } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { IAuthenticationReducer } from 'types/autentication'
import { RootReducerState } from 'types/global'
import {
    TitleNotifications,
    Top,
    TopInputs
} from './styles'

interface TopHeaderProps {
    control: Control<FieldValues, any>
    currentLocationList: any[]
    currentSectorList: any[]
    isEnabledLocationFilter: boolean
    isEnabledSectorFilter: boolean
    onChangeLocation?: any
    onChangeSector?: any
    selectAll?: any
}

function TopHeaderNotifications({
    control,
    currentLocationList,
    currentSectorList,
    isEnabledLocationFilter,
    isEnabledSectorFilter,
    onChangeLocation,
    onChangeSector,
    selectAll
}: TopHeaderProps) {
    const auth: IAuthenticationReducer = useSelector((state: RootReducerState) => state.authenticationReducers)
    return (
        <Top>
            <TitleNotifications data-testid="notifications">
                Gestão das Notificações
            </TitleNotifications>

            <TopInputs>
                <div>
                    <InputSelect
                        multiUnitText="Unidades"
                        unitText="Unidade"
                        defaultValue={''}
                        allIsSelected={false}
                        multiple={false}
                        searchPlaceHolder="Buscar"
                        shouldHaveSearch={true}
                        onChange={onChangeLocation}
                        styleBoxOptions="mt-3 w-[280px]"
                        styleContainer="w-[280px] bg-white"
                        label="Unidade"
                        name="unity"
                        disabled={!isEnabledLocationFilter}
                        control={control}
                        data={currentLocationList}
                        placeholder={auth?.dataJwt?.profile === 'location_manager' ? "Selecionar" : "Todas"}
                    />
                </div>
                <div>
                    <InputSelect
                        multiUnitText="Setores"
                        unitText="Setor"
                        onChange={onChangeSector}
                        defaultValue={[]}
                        allIsSelected={true}
                        multiple={true}
                        searchPlaceHolder="Buscar"
                        shouldHaveSearch={true}
                        styleBoxOptions="mt-3 w-[280px]"
                        styleContainer="w-[280px] bg-white"
                        label="Setor notificado"
                        name="sector"
                        disabled={!isEnabledSectorFilter}
                        control={control}
                        data={currentSectorList}
                        placeholder="Todas"
                        selectAll={selectAll}
                    />
                </div>
            </TopInputs>
        </Top>
    )
}

export { TopHeaderNotifications }

